// @vendor
const { Promise } = require('es6-promise');
const moment = require('moment');
// @constants
const actionTypes = require('constants/actionTypes');
// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

function requestWarrantFileSuccess(response) {
    return {
        type: actionTypes.BROKER_GET_PRODUCT_FILE_SUCCESS,
        payload: {
            data: response
        }
    };
}

function requestWarrantFileFailure(response) {
    return {
        type: actionTypes.BROKER_GET_PRODUCT_FILE_FAILURE,
        payload: {
            data: response
        }
    };
}

function requestWarrantFile(dispatch, isin, iso, screen) {
    return new Promise(function () {
        const requestData = {
            query: {
                instrumentId: isin,
                micCode: iso.trim(),
                screen
            }
        };
        return APIGet(dispatch, apiURLBuilder.getURL('warrantFile'), requestData)
            .then(function(response) {
                dispatch(requestWarrantFileSuccess(response));
            }, function(response) {
                dispatch(requestWarrantFileFailure(response))
            }
        );
    });
}

function requestHistoricalFetching() {
    return {
        type: actionTypes.BROKER_GET_HISTORICAL_FETCHING
    };
}

function requestHistoricalSuccess(response) {
    return {
        type: actionTypes.BROKER_GET_HISTORICAL_SUCCESS,
        payload: {
            data: response
        }
    };
}

function requestHistoricalFailure(response) {
    return {
        type: actionTypes.BROKER_GET_HISTORICAL_FAILURE,
        payload: {
            data: response
        }
    };
}

const requestHistoricalData = (dispatch, isin, iso) => {
    const requestData = {
        query: {
            instrumentId: isin,
            micCode: iso.trim(),
            historical: true,
            orderBy: 'ASC',
            since: moment().subtract(12, 'months').format("YYYY-MM-DD")
        }
    };

    dispatch(requestHistoricalFetching());

    return APIGet(dispatch, apiURLBuilder.getURL('warrantFileHistorical'), requestData)
        .then(function(response) {
            dispatch(requestHistoricalSuccess(response));
        }, function(response) {
            dispatch(requestHistoricalFailure(response))
        }
    );
};

const getCatalogueDetails = (isin, dispatch) => {
  const requestData = {
    query: {
      text: isin,
      pageSize: 5,
      pageSizeGroup: 10,
      pageNumber: 1,
    },
  };

  dispatch(requestWarrantsCatalogueFetching());

  return APIGet(dispatch, apiURLBuilder.getURL('catalogueBrokerAdvancedSearch'), requestData)
    .then(response => dispatch(requestWarrantsCatalogueSuccess(response)))
    .catch(() => dispatch(requestWarrantsCatalogueFailure()));
};

const requestWarrantsCatalogueFetching = () => {
  return {
    type: actionTypes.BROKER_WARRANT_CATALOGUE_FETCHING,
  };
};

const requestWarrantsCatalogueSuccess = data => {
  return {
    type: actionTypes.BROKER_WARRANT_CATALOGUE_SUCCESS,
    payload: data,
  };
};

const requestWarrantsCatalogueFailure = () => {
  return {
    type: actionTypes.BROKER_WARRANT_CATALOGUE_FAILURE,
  };
};

const getWarrantFile = (isin, iso, screen) => (dispatch) => (requestWarrantFile(dispatch, isin, iso, screen));
const getHistoricalRequest = (isin, iso) => (dispatch) => (requestHistoricalData(dispatch, isin, iso));
const getWarrantCatalogueDetails = (isin) => (dispatch) => (getCatalogueDetails(isin, dispatch));

module.exports = {
    getWarrantFile,
    getHistoricalRequest,
    getWarrantCatalogueDetails
}

